"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Placeholder = exports.ImageComponent = exports.IMAGE_SIZE = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
const IMAGE_SIZE = exports.IMAGE_SIZE = 80;
const PADDING = 3;
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  aspectRatio: '1',
  backgroundColor: theme.palette.grey[100],
  boxSizing: 'border-box',
  borderRadius: theme.spacing(1),
  position: 'relative',
  padding: theme.spacing(PADDING, 0),
  height: `calc(${IMAGE_SIZE}px + ${theme.spacing(PADDING * 2)})`,
  width: IMAGE_SIZE
}));
const ImageComponent = exports.ImageComponent = (0, _mui.styled)(_presentationComponents.Image)({
  objectFit: 'contain'
});
const Placeholder = exports.Placeholder = (0, _mui.styled)(Root)(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  height: `calc(${IMAGE_SIZE}px + ${theme.spacing(PADDING * 2)})`,
  width: IMAGE_SIZE,
  '& svg': {
    color: theme.palette.grey[200],
    fontSize: '3rem'
  }
}));